import React from 'react';
import {useMediaQuery} from "react-responsive";
function PartnerLogos() {
    const isSmallScreen = useMediaQuery({ maxWidth: 575 });
    return (
        <div className={`${isSmallScreen ? "h-px-200 overflow-hidden" : "h-px-400 overflow-hidden"}`}>
            <div className="divider pb-1 mb-5">
                <div className="divider-text display-5">
                    <h6 className="display-6">Ils nous font confiance</h6>
                </div>
            </div>
            <div className="partner-logos-container">
                <img className="partner-logo" src={require("../assets/img/PartnerLogos/logo_darrasa_bleu2-03.png")}
                     alt="partner"/>
                <img className="partner-logo" src={require("../assets/img/PartnerLogos/logo_netikash_subscribe.png")}
                     alt="partner"/>
                <img className="partner-logo" src={require("../assets/img/PartnerLogos/Divinashop.png")}
                     alt="partner"/>
                <img className="partner-logo" src={require("../assets/img/PartnerLogos/Karibu Congo Logo.png")}
                     alt="partner"/>
                <img className="partner-logo" src={require("../assets/img/PartnerLogos/64 Bits.png")}
                     alt="partner"/>

            </div>
        </div>
    );
}

export default PartnerLogos;
